import { ScrollView } from "react-native";
import { Stack, useRouter } from "expo-router";
import { useUnistyles } from "react-native-unistyles";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { ManageExceptionsContent } from "@src/features/alarms/components/ManageExceptionsContent";
import { useAggregatedExceptions } from "@src/features/alarms/hooks/useAggregatedExceptions";
import { useSiteCameraKeys } from "@src/features/cameras/hooks/useSiteCameraKeys";
import { useHeaderBackButton } from "@src/hooks/useHeaderBackButton";

export default function ManageExceptionsScreen() {
  const { theme } = useUnistyles();
  const { bottom } = useSafeAreaInsets();
  const router = useRouter();
  const { cameraKeys, selectedSiteId } = useSiteCameraKeys();
  const effectiveSiteId = selectedSiteId ?? "";
  const { headerLeft } = useHeaderBackButton();
  const { isLoading, exceptions: aggregatedExceptions } = useAggregatedExceptions(effectiveSiteId, cameraKeys);

  return (
    <>
      <Stack.Screen options={{ title: "Exceptions", headerLeft }} />
      <ScrollView
        style={{ flex: 1, backgroundColor: theme.colors.background }}
        contentContainerStyle={{
          paddingHorizontal: theme.spacing["3xl"],
          paddingTop: theme.spacing["4xl"],
          paddingBottom: bottom + theme.spacing["6xl"],
          flexGrow: 1,
          backgroundColor: theme.colors.background,
        }}
        showsVerticalScrollIndicator={false}
      >
        <ManageExceptionsContent
          isLoading={isLoading}
          exceptions={aggregatedExceptions}
          onEditException={(group) =>
            router.push({
              pathname: "/alarm-settings/edit-exception",
              params: {
                exception: JSON.stringify({ reason: group.reason, action: group.action, period: group.period }),
                includedCameraKeys: JSON.stringify(group.cameraKeys),
                timezone: group.timezone,
              },
            })
          }
          onCreateException={() => router.push("/alarm-settings/create-exception")}
        />
      </ScrollView>
    </>
  );
}
